// stores
import useWriteCampaignStore from '@/stores/WriteCampaign';
import useReadCampaignStore from '@/stores/ReadCampaign';
// constants
import { MIN_SUGGESTED_KEYWORDS, MIN_SUGGESTED_PRODUCTS, MIN_SUGGESTED_CITIES, MIN_SUGGESTED_KEYWORDS_FOR_BROAD, } from '@/pages/instamart/campaign/create/widgets/Nudge/constants';
import { AD_GROUP_INDEX } from '@/constants/campaign';
// defs
import { KeywordMatchType } from '@local/typedefs/dist/protos/campaign/Criteria';
import { CampaignStatus } from '@local/typedefs/dist/protos/campaign/Campaign';
const useNudge = (isEditMode) => {
    const { selectedProducts, selectedKeywords, selectedCities } = useWriteCampaignStore((store) => ({
        selectedProducts: store.adGroups[AD_GROUP_INDEX].candidates,
        selectedKeywords: store.adGroups[AD_GROUP_INDEX].keywords,
        selectedCities: store.cityIds,
    }));
    const { campaign: readCampaign } = useReadCampaignStore();
    const isProductNudgeVisible = selectedProducts.length < MIN_SUGGESTED_PRODUCTS;
    const isKeywordNudgeVisible = selectedKeywords.length < MIN_SUGGESTED_KEYWORDS;
    const campaignStatus = readCampaign
        ? readCampaign.status
        : CampaignStatus.CAMPAIGN_STATUS_INVALID;
    const isCityNudgeVisible = selectedCities.length < MIN_SUGGESTED_CITIES &&
        (isEditMode
            ? campaignStatus !== CampaignStatus.CAMPAIGN_STATUS_LIVE
            : true);
    const isBroadKeywordNudgeVisible = selectedKeywords.length >= MIN_SUGGESTED_KEYWORDS &&
        selectedKeywords.length < MIN_SUGGESTED_KEYWORDS_FOR_BROAD &&
        !selectedKeywords.some((kw) => kw.matchType === KeywordMatchType.KEYWORD_MATCH_TYPE_BROAD);
    const isAnyNudgeVisible = isProductNudgeVisible ||
        isKeywordNudgeVisible ||
        isCityNudgeVisible ||
        isBroadKeywordNudgeVisible;
    return {
        isProductNudgeVisible,
        isKeywordNudgeVisible,
        isCityNudgeVisible,
        isBroadKeywordNudgeVisible,
        isAnyNudgeVisible,
    };
};
export default useNudge;
